<template>
  <div>
    <!-- <PageLoader v-bind:storage="appLoading" /> -->
     <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="50"
      is-full-screen
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#68D389" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left align-self-center>{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex xs12>
        <CarouselItem
          
        />
        <!-- v-bind:storage="caraouselitems"
          v-bind:category="category"
          :key="category.length" -->
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex xs12>
        <History
          v-bind:programs="programs"
          v-bind:programlen="programlen"
          v-bind:halfsize="halfsize"
          :key="programs.length"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex xs12>
        <About
        />
      </v-flex>
    </v-layout>
     <v-layout wrap justify-center>
      <v-flex xs12>
        <EcoTourism
        />
      </v-flex>
    </v-layout>
      <v-layout wrap justify-center>
      <v-flex xs12>
        <Programs
        />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
// import axios from "axios";
import CarouselItem from "./carouselItem";
import History from "@/components/Home/history";
import About from "@/components/Home/about";
import EcoTourism from "@/components/Home/ecoTourism";
import Programs from "@/components/Home/programs";
export default {
  components: {
    CarouselItem,
    History,
    About,
    EcoTourism,
    Programs
  },
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      category: [],
      programs: [],
      programlen: null,
      halfsize: null,
      model: 0,
      caraouselitems: [
        {
          image: "Home.jpg",
          quote:
            "Where humans and <br/> the wild things, <br />peacefully co-exist",
        },
        {
          image: "Home2.jpg",
          quote:
            "Among the top ten <br/> best managed <br/> Tiger Reserves <br/> in the country ",
        },
      ],
    };
  },
//   beforeMount() {
//     this.getData();
//     this.getPrograms();
//     this.getCarousel();
//   },
//   methods: {
//     getData() {
//       this.appLoading = true;
//       axios({
//         method: "GET",
//         url: "/category/getlist",
//       })
//         .then((response) => {
//           this.appLoading = false;
//           this.category = response.data.data;
//         })
//         .catch((err) => {
//           this.appLoading = false;
//           this.ServerError = true;
//           console.log(err);
//         });
//     },
//     getPrograms() {
//       this.appLoading = true;
//       axios({
//         method: "GET",
//         url: "/programme/getlist?started=true",
//       })
//         .then((response) => {
//           this.appLoading = false;
//           this.programs = response.data.data;
//           this.programlen = response.data.data.length;
//           this.halfsize = response.data.data.length / 2;
//         })
//         .catch((err) => {
//           this.appLoading = false;
//           this.ServerError = true;
//           console.log(err);
//         });
//     },

//     getCarousel() {
//       axios({
//         method: "GET",
//         url: "/carousel/getrandom",
//       })
//         .then((response) => {
//           this.caraouselitems = response.data.data;
//         })
//         .catch((err) => {
//           console.log(err);
//         });
//     },
//   },
};
</script>